import { toast } from "sonner";
import { updateResults } from "./api";
import { useMutation } from "@tanstack/react-query";
import { invalidateAllQueries } from "utils/utils";

function buildPayload(values) {
    const payload = {};

    Object.entries(values).forEach(([key, value]) => {
        if (
            ![].includes(key)
        ) {
            payload[key] = value;
        }
    });

    return payload;
}

export function useResultsUpdate() {
    return useMutation({
        mutationFn: async ({ caseStudyId, values }) => {
            const payload = buildPayload(values);

            const response = await updateResults({ caseStudyId, item: payload });
            return response;
        },
        onSuccess: () => {
            invalidateAllQueries();
            toast.success("Results Updated Successfully");
        },
        onError: (error) => {
            toast.error(error.message);
            console.log(error.message);
        },
    });
}
